import { render, staticRenderFns } from "./Header-v3.vue?vue&type=template&id=32872a2a&scoped=true"
import script from "./Header-v3.vue?vue&type=script&lang=js"
export * from "./Header-v3.vue?vue&type=script&lang=js"
import style0 from "./Header-v3.vue?vue&type=style&index=0&id=32872a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.4_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._jca7zi6wchtjyzx47wtnuj7qfi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32872a2a",
  null
  
)

export default component.exports